import {
    CAR_DATA_MASTER_SET_DRAFT_DATA,
} from './constants'

export function setPricesDraftData(data){
    return {
        type: CAR_DATA_MASTER_SET_DRAFT_DATA,
        data: data
    };
}

export function reducer(state, action){
    switch (action.type){
        case CAR_DATA_MASTER_SET_DRAFT_DATA:
            return {
                ...state,
                pricesDraftData: action.data
            };
        default:
            return state;
    }
}